// extracted by mini-css-extract-plugin
export default {"container":"styles_container__q4rlz","textOne":"styles_textOne__OibaU","listContainer":"styles_listContainer__P3gIh","item":"styles_item__LLo8P"};